import { Directive, HostBinding, HostListener, OnDestroy, inject, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Logger } from '@utils';

@Directive({
  selector: '[uiCopyToClipboard]',
  standalone: true,
  providers: [MatTooltip],
})
export class CopyToClipboardDirective implements OnDestroy {
  private readonly tooltip = inject(MatTooltip);

  readonly copyContent = input.required<string>();
  readonly tooltipText = input<string>('Copied!');

  private timeoutId: number | null = null;

  @HostBinding('style.cursor') cursor = 'pointer';

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  @HostListener('click', ['$event'])
  async onCopy(event: MouseEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(this.copyContent());
      this.showTooltip(this.tooltipText());
    } catch (error) {
      this.showTooltip('Failed to copy');
      Logger.error('Failed to copy to clipboard:', error);
    }
  }

  private showTooltip(message: string): void {
    // Clear any existing timeout
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Set message and show tooltip
    this.tooltip.message = message;
    this.tooltip.show();

    // Hide after 3 seconds
    this.timeoutId = window.setTimeout(() => {
      this.tooltip.hide();
      this.timeoutId = null;
    }, 3000);
  }
}
